import { z } from 'zod';

export const ExpenseKmManualChangeSchema = z.object({
  field: z.enum(['date', 'origin', 'destination']),
  /** The original value, as text — an ISO instant for `date`. */
  from: z.string(),
  /** The value the traveler typed in its place. */
  to: z.string(),
});

/** The GPS numbers of a tracked mileage refund (source `expense.tracked`), no location:
 *  evidence for the approver, never the amount, which is always the A→B route. */
export const ExpenseKmTrackedSchema = z.object({
  outcome: z.enum(['GPS', 'ABOVE_CAP', 'ROUND_TRIP', 'GAP_FALLBACK']),
  gpsKm: z.number(),
  routeKm: z.number(),
  pointCount: z.number().int().nonnegative(),
  gapKm: z.number().nonnegative(),
});
export type ExpenseKmTracked = z.infer<typeof ExpenseKmTrackedSchema>;
